import {SET_E_WALLET} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  
  selectedData: null,
  formType: "",
  formId: "",
  formTitle: "",

  image: null,
  imageSize: {
    label: 'Small',
    value: 'S'
  },
  walletCode: '',
  walletName: '',
  totalBalanceKey: '',
  earnedTodayKey: '',
  balanceKey: '',
  sort: 0,
  isShowDuration: false,
  durationStartDate: '',
  durationEndDate: '',
  isShowWallet: false,
  isHideZeroBal: false,
  isShowRedeem: false,
  isShowEarnedToday: false,
  isShowTotalBal: false,

  cardType: [],
  excludedCardType: [],
  specificUser: [],
  blacklistedUser: [],
  deviceType: {
    label: 'All',
    value: 'ALL'  
  },
  isUploadingCSVFile: false,
  isUploadingCSVFileBlacklistedUser: false,

  imageSizeOptions: [
    {
      label: 'Small',
      value: 'S'
    },
    {
      label: 'Large',
      value: 'L'
    }
  ],
  deviceTypeOptions: [
    {
      label: 'ALL',
      value: 'ALL'  
    },
    {
      label: 'ANDROID',
      value: 'ANDROID'  
    },
    {
      label: 'IOS',
      value: 'IOS'  
    },
  ]
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case SET_E_WALLET:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/EWallet.js